import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const AdminRouteNotFound: React.FC = () => {
  const loc = useLocation();
  React.useEffect(() => {
    try { console.warn('[AdminRouteNotFound] 404 at', loc.pathname, 'search=', loc.search); } catch {}
  }, [loc]);
  return (
    <div style={{ padding: 16 }}>
      <Card>
        <Title level={4} style={{ marginTop: 0 }}>未匹配到路由 (管理员)</Title>
        <Paragraph>当前路径：{loc.pathname}{loc.search}</Paragraph>
        <Paragraph type="secondary">
          调试建议：
          <ul>
            <li>确认路径是否为 /dashboard/admin/instructions/create</li>
            <li>前端已重新编译并刷新</li>
          </ul>
        </Paragraph>
        <Link to="/dashboard/admin">返回管理员首页</Link>
      </Card>
    </div>
  );
};

export default AdminRouteNotFound;


